import { render, staticRenderFns } from "./PassiveStockDashboard.vue?vue&type=template&id=1f0b7813&scoped=true"
import script from "./PassiveStockDashboard.vue?vue&type=script&lang=js"
export * from "./PassiveStockDashboard.vue?vue&type=script&lang=js"
import style0 from "./PassiveStockDashboard.vue?vue&type=style&index=0&id=1f0b7813&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0b7813",
  null
  
)

export default component.exports